var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-message',{attrs:{"closable":false,"title":_vm.title,"type":"is-danger","has-icon":""}},[_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index},[_vm._v(" - "+_vm._s(error.message)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }